import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import http from '../axios/axios.instance';

export function useNotificationSeen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const processedRef = useRef(new Set());

  useEffect(() => {
    const nid = searchParams.get('nid');
    if (!nid || processedRef.current.has(nid)) return;
    processedRef.current.add(nid);

    http.patch(`/api/v1/user/notifications/${nid}/seen`).catch(() => {});

    searchParams.delete('nid');
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);
}
